<div class="video-player" fxLayout="column" fxLayoutGap="16px">
    <div fxLayout="row" fxLayoutAlign="end center">
        <button mat-icon-button mat-ripple (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content fxLayout="column" fxLayoutGap.lt-md="32px" fxLayout.gt-sm="row" fxLayoutAlign="center center">
        <youtube-player
            [width]="player.width"
            [height]="player.height"
            [videoId]="player.videoId"
            [endSeconds]="player.endSeconds"
            [startSeconds]="player.startSeconds"
            [suggestedQuality]="player.suggestedQuality"
        >
        </youtube-player>
    </div>
</div>
